import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ControlTamañoService {
  private endpoint = environment.ApiConecta;

  constructor(private http: HttpClient) {}

  documentCompressor(document: string): Observable<any> {
    const url = `${this.endpoint}document-compressor`;
    return this.http.post(url, {
      documento: document,
      critico: 1,
    });
  }
}
